import { render, staticRenderFns } from "./draftbox.vue?vue&type=template&id=04dc503c&scoped=true&"
import script from "./draftbox.vue?vue&type=script&lang=js&"
export * from "./draftbox.vue?vue&type=script&lang=js&"
import style0 from "./draftbox.vue?vue&type=style&index=0&id=04dc503c&lang=less&scoped=true&"
import style1 from "./draftbox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc503c",
  null
  
)

export default component.exports